import { TIME_MASK_PLACEHOLDER } from '../../../constants/date'

export const TIME_INPUT_FORMAT_HINT = TIME_MASK_PLACEHOLDER

export const TIME_INPUT_FORMAT_MAX_LENGTH = 5
